"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpItemBubble = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var react_i18next_1 = require("react-i18next");
var Common_1 = require("../../Common");
var DpItemBubble_styled_1 = require("./DpItemBubble.styled");
var api_1 = require("../../../api");
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var DpItemBubble = function (_a) {
    var label = _a.label, item = _a.item, selectHandler = _a.selectHandler, status = _a.status, type = _a.type, pointsAwarded = _a.pointsAwarded, totalMaxScore = _a.totalMaxScore, activeItem = _a.activeItem, itemBubbleAriaLabel = _a.itemBubbleAriaLabel;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // ---------------------------- Events
    var select = function () {
        if (selectHandler) {
            selectHandler(item);
        }
    };
    // ---------------------------- Methods
    var getIconName = function (responseStatus) {
        return responseStatus === api_1.ItemResponseStatus.Correct
            ? 'check'
            : responseStatus === api_1.ItemResponseStatus.PartiallyCorrect
                ? 'minus'
                : 'x';
    };
    var isActive = activeItem === item;
    // ---------------------------- Render
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, { overlay: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Tooltip, { id: "status_".concat(status), placement: "top", className: "status-tooltip", role: "tooltip", children: [(0, jsx_runtime_1.jsx)("span", { className: "status-name", children: t("itemBubble.".concat(status)) }), (0, jsx_runtime_1.jsx)("br", {}), status !== api_1.ItemResponseStatus.NotScored &&
                    !(0, isUndefined_1.default)(pointsAwarded) &&
                    !(0, isUndefined_1.default)(totalMaxScore) && ((0, jsx_runtime_1.jsx)("span", { className: "status-score", children: "".concat(pointsAwarded.toString(), " / ").concat(totalMaxScore.toString()) }))] }), children: (0, jsx_runtime_1.jsxs)(DpItemBubble_styled_1.StyledDpItemBubble, { onClick: select, status: status, tabIndex: 0, className: "btn-clearfix", "aria-label": itemBubbleAriaLabel, "aria-pressed": isActive, "data-testid": "dp-item-bubble", children: [(0, jsx_runtime_1.jsx)("div", { className: "status-container", children: (0, jsx_runtime_1.jsx)("div", { className: "circle ".concat(type, " ").concat(isActive ? 'active' : 'inactive'), children: (0, jsx_runtime_1.jsx)("div", { className: "icon-container", children: status === api_1.ItemResponseStatus.NotScored ? '?' : (0, jsx_runtime_1.jsx)(Common_1.Icon, { name: getIconName(status) }) }) }) }), label] }) }));
};
exports.DpItemBubble = DpItemBubble;
